import sanityClient from '@sanity/client';

export default sanityClient({
  projectId: 'eh3opl2e', // from sanity.io
  dataset: 'production',
  apiVersion: '2023-10-01',       // fixed date
  useCdn: false,                  // set false while debugging to see real errors
  perspective: 'published'
});
